import _ from 'lodash';
import metadataTechnology from './metadata-technology.json';
import metadataTechnologies from './metadata-technologies.json';

/**
 * Universal/Isomorphic code
 */
export default {
  getTechnologyTitle,
  seo
};

function getTechnologyTitle(technologies, technology) {
  if (!technology) {
    return '';
  }

  return technologies.filter(item => item.hash === technology)[0].title;
}

function seo(isTechnology, path, technologyTitle) {
  let metadata = isTechnology ? metadataTechnology : metadataTechnologies;
  metadata = _.clone(metadata);
  metadata.opengraph['og:url'] = `https://auth0.com${path}`;
  if (isTechnology) {
    const title = metadata.title.replace('`${technology}`', technologyTitle);
    const description = metadata.metas.description.replace('`${technology}`', technologyTitle);
    metadata.title = title;
    metadata.opengraph['og:title'] = title;
    metadata.twittercard['twitter:title'] = title;
    metadata.metas.description = description;
    metadata.opengraph['og:description'] = description;
    metadata.twittercard['twitter:description'] = description;
  }

  return metadata;
}



// WEBPACK FOOTER //
// ./src/pages/auth-catalog-index/universal/utils.js